import { FC } from 'react';
import { UploadedFile } from './filigrane.types';
import FiligraneCard, { FiligraneCardSize } from './FiligraneCard';
import './StepPreview.scss';
import { ReactComponent as IconTrash } from "assets/img/icons/icon_Trash2.svg";
import { ReactComponent as IconAddFile } from "assets/img/icons/icon_AddFile.svg";


interface Props {
  files: UploadedFile[];
  selectedIds: string[];
  onToggle: (id: string) => void;
  onSelectAll: () => void;
  onDeleteSelected: () => void;
  onAddMore: () => void;
  onNext: () => void;
}

const StepPreview: FC<Props> = ({
  files,
  selectedIds,
  onToggle,
  onSelectAll,
  onDeleteSelected,
  onAddMore,
  onNext,
}) => {
  const allSelected = files.length > 0 && selectedIds.length === files.length;

  // 1 file → xl centered · 2 → lg · 3 → md · 4+ → sm
  const cardSize: FiligraneCardSize =
    files.length === 1 ? 'xl' : files.length === 2 ? 'lg' : files.length === 3 ? 'md' : 'sm';

  return (
    <div className="step-preview">
      <div className="step-preview__area">
        {/* Toolbar */}
        {files.length !== 0 && (
          <div className="step-preview__toolbar">
            <button
              className="step-preview__select-all"
              onClick={onSelectAll}
              type="button"
              aria-label="Tout sélectionner"
            >
              <div className={`step-preview__checkbox-box${allSelected ? ' step-preview__checkbox-box--checked' : ''}`}>
                {allSelected && <span>✓</span>}
              </div>
              <span className="step-preview__label">tout sélectionner</span>
            </button>
            <div className="step-preview__divider" aria-hidden="true" />
            <button
              className="step-preview__delete-btn"
              onClick={onDeleteSelected}
              type="button"
              disabled={selectedIds.length === 0}
            >
              <IconTrash fill={"#FF5326"}/>
              supprimer
            </button>
          </div>
        )}

        {/* Grid */}
        <div className={`step-preview__grid${files.length === 1 ? ' step-preview__grid--single' : ''}`}>
          {files.length === 0
            ? <p className="step-preview__empty">Aucun fichier importé.</p>
            : files.map(file => (
                <FiligraneCard
                  key={file.id}
                  id={file.id}
                  name={file.file.name}
                  previewUrl={file.previewUrl}
                  fileType={file.file.type === 'application/pdf' ? 'pdf' : 'image'}
                  isSelected={selectedIds.includes(file.id)}
                  onToggle={onToggle}
                  variant="upload"
                  size={cardSize}
                />
              ))
          }
        </div>

        {/* Actions */}
        <div className="step-preview__actions">
          <button className="step-preview__add-btn" onClick={onAddMore} type="button">
            <IconAddFile />
            <span>ajouter</span>
          </button>
          <button
            className="step-preview__next-btn"
            onClick={onNext}
            type="button"
            disabled={selectedIds.length === 0}
          >
            <span>aposer filigrane</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default StepPreview;
